import { render, staticRenderFns } from "./answerConfirm.vue?vue&type=template&id=5b9160be&scoped=true&"
import script from "./answerConfirm.vue?vue&type=script&lang=js&"
export * from "./answerConfirm.vue?vue&type=script&lang=js&"
import style0 from "./answerConfirm.vue?vue&type=style&index=0&id=5b9160be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9160be",
  null
  
)

export default component.exports